//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { request } from '@/tools/index.js'
import { jssdk, isIphonex } from '@runwork/runwork-help'
import Detail from '@/pages/detail/Index.vue'
export default {
  name: 'preview-page',
  data() {
    return {
      currentIndex: 0,
      isRW3: undefined, // 平台标志 3.0 true
      isSurveyAdmin: false,
      item: { data: { returnData: { questionnaireDto: {} } } },
      isShow: false,
    }
  },
  components: {
    Detail,
  },
  computed: {
    isIphonex() {
      return isIphonex() && this.platform === 3
    },
    isrunwork2() {
      return isIphonex() && this.platform === 2
    },
  },
  watch: {},
  async created() {
    const loading = new this.$Loading()
    try {
      await this.$nativeBridgeReady()
      await this.init()
      console.log('平台：', window.h5sdk ? 3.0 : 2.0)
      this.isRW3 = window.h5sdk ? true : false
      loading.close()
    } catch (err) {
      console.log(err)
      loading.close()
    }
  },
  methods: {
    async checkSurveyAdmin() {
      const userCode = this.user.ldap
      return request('checkSurveyAdmin', { userCode }).then((res) => {
        this.isSurveyAdmin = res
      })
    },
    init() {
      let promiseArr = [this.getItem(), this.checkSurveyAdmin()]
      return Promise.all(promiseArr)
    },
    onSubmitClicked() {
      if (!this.isSurveyAdmin) {
        new this.$Toast({
          text: '暂无权限，请联系管理员开通相关权限',
          time: 1500,
          position: 'top',
          distance: '50%',
        })
        return
      } else {
        const userCode = this.user.ldap
        const params = {
          userCode,
          templateId: this.$route.query.questionnaireId,
        }
        return request('addQuestionnaireByTemplate', params).then((res) => {
          this.$router.push({
            name: 'createItem',
            query: {
              questionnaireId: res.questionnaireId,
            },
          })
        })
      }
    },
    onCancelClicked() {
      this.$router.push({
        name: 'create',
      })
    },
    getItem() {
      const params = {
        templateId: this.$route.query.questionnaireId,
      }
      return request('queryInfoByTemplateId', params).then((res) => {
        this.isShow = true
        this.item = { data: { returnData: { questionnaireDto: res } } }
      })
    },
  },
}
